























import { defineComponent } from '@nuxtjs/composition-api';
import BaseLink from '@shared/components/@atoms/BaseLink/BaseLink.vue';
import BaseMenuItem from '@shared/components/@molecules/BaseMenuItem/BaseMenuItem.vue';

export default defineComponent({
  name: 'BaseHeaderNavigationItem',
  components: {
    BaseLink,
    BaseMenuItem,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    link: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    // @ts-ignore migrated from ui-library
    isVisibleOnMobile() {
      // @ts-ignore migrated from ui-library
      return this.isMobile;
    },
  },
});
